import { render } from "./RichList.vue?vue&type=template&id=b81009aa&scoped=true"
import script from "./RichList.vue?vue&type=script&lang=js"
export * from "./RichList.vue?vue&type=script&lang=js"

import "./RichList.vue?vue&type=style&index=0&id=b81009aa&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81009aa"]])

export default __exports__